import React from 'react'

function PagenotFound() {
    return (
        <div style={{ width: "100%", height: "100vh", margin: "auto", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img src="https://media.tenor.com/OyUVgQi-l-QAAAAC/404.gif" alt="page not found" />
        </div>
    )
}

export default PagenotFound